import { useState, useEffect } from "react";
import Modal from "./Modal";
import { useForm } from "react-hook-form";
import BirthDataForm from "../Forms/BirthDataForm";

const EditProfileModal = ({ isOpen, onClose, user, onUpdate, isUpdating }) => {
	const [activeTab, setActiveTab] = useState("general"); // 'general' or 'birth'

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm({
		defaultValues: {
			name: user?.name || "",
			email: user?.email || "",
		},
	});

	useEffect(() => {
		if (user) {
			reset({
				name: user.name,
				email: user.email,
			});
		}
	}, [user, reset]);

	const onGeneralSubmit = (data) => {
		onUpdate(data);
	};

	const onBirthDataSubmit = (data) => {
		onUpdate(data);
	};

	if (!user) return null;

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Edit Profile"
			className="max-w-2xl"
		>
			<div className="flex gap-4 mb-6 border-b border-gray-100">
				<button
					className={`pb-2 px-4 font-medium transition-colors ${
						activeTab === "general"
							? "text-indigo-600 border-b-2 border-indigo-600"
							: "text-gray-500 hover:text-gray-700"
					}`}
					onClick={() => setActiveTab("general")}
				>
					General Info
				</button>
				<button
					className={`pb-2 px-4 font-medium transition-colors ${
						activeTab === "birth"
							? "text-indigo-600 border-b-2 border-indigo-600"
							: "text-gray-500 hover:text-gray-700"
					}`}
					onClick={() => setActiveTab("birth")}
				>
					Birth Data
				</button>
			</div>

			{activeTab === "general" ? (
				<form onSubmit={handleSubmit(onGeneralSubmit)} className="flex flex-col gap-4">
					<div className="flex flex-col gap-1">
						<label className="text-sm font-medium text-gray-700">Name</label>
						<input
							{...register("name", { required: "Name is required" })}
							className="px-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							placeholder="Your Name"
						/>
						{errors.name && (
							<span className="text-sm text-red-500">{errors.name.message}</span>
						)}
					</div>

					<div className="flex flex-col gap-1">
						<label className="text-sm font-medium text-gray-700">Email</label>
						<input
							{...register("email", {
								required: "Email is required",
								pattern: {
									value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
									message: "Invalid email address",
								},
							})}
							type="email"
							className="px-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							placeholder="your@email.com"
						/>
						{errors.email && (
							<span className="text-sm text-red-500">{errors.email.message}</span>
						)}
						<p className="text-xs text-gray-500">
							Changes to your email will require verification.
						</p>
					</div>

					<div className="flex justify-end gap-3 mt-4">
						<button
							type="button"
							onClick={onClose}
							className="px-4 py-2 rounded-lg text-gray-600 hover:bg-gray-100 font-medium"
						>
							Cancel
						</button>
						<button
							type="submit"
							disabled={isUpdating}
							className="px-6 py-2 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-50"
						>
							{isUpdating ? "Saving..." : "Save Changes"}
						</button>
					</div>
				</form>
			) : (
				<div>
					<BirthDataForm 
						defaultValues={{
							locationName: user.location?.name,
							timezone: user.timezone,
							// birth form handles parsing user.date object
						}} 
            // We pass submitting state down? BirthDataForm has its own submitting prop
						onSubmit={onBirthDataSubmit}
            submitting={isUpdating}
			isUpdateProfile={true}
					/>
				</div>
			)}
		</Modal>
	);
};

export default EditProfileModal;
